/**
 * Extracts the user metadata from the frontend meta tags
 *   First Name
 *   Preferred Name
 *
 * Overwrites the biography title with a dynamic name title
 */
document.addEventListener('DOMContentLoaded', () => {
  const components = document.querySelectorAll(`[data-component="profile-biography"]`);

  if (components.length) {
    const data = {
        firstName: document.querySelector('meta[name="first_name"]')?.content ?? '',
        preferredName: document.querySelector('meta[name="preferred_name"]')?.content ?? '',
    };

    const name = data.preferredName ? data.preferredName : data.firstName;
    const title = document.querySelector('[data-profile-biography-title]');

    if (name && title) {
        title.innerHTML = "About " + name;
    }
  }
});

